import "./styles.css";
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Container, Row, Stack } from 'react-bootstrap';
import Menu from './Menu';
import Header from './Header';
import PieChart from './PieChart';
import DataTable from './DataTable';
import DataContextProvider from './DataContextProvider';
import ArticleDashboard from './ArticleDashboard';
import ItemDashboard from './ItemDashboard';
import Lists from './Lists';
import List from './List';
import EditList from './EditList';
import CustomDashboard from './CustomDashboard';
import Settings from './Settings';
import Help from './Help';
import Insights from './Insights';

export default function App() {
  const [user, setUser] = React.useState({});

  React.useEffect(() => {
    const next = window.location.href;
    fetch(`/api/user?next=${next}`).then(response => response.json()).then(data => {
      if (data.redirect_url) {
        window.location.href = data.redirect_url;
      }
      else if (data.name) {
        setUser(data);
      }
    });
  }, []);

  return (
    <Container fluid className="app">
      {user.name &&
        <BrowserRouter>
          <Row className="main-row">
            <DataContextProvider>
              <Stack direction="horizontal">
                <Menu user={user} />
                <div className="content">
                  <Routes>
                    <Route path="/" element={<ArticleDashboard withSplits />} />
                    <Route path="/articles/:id" element={<ArticleDashboard />} />
                    <Route path="/products/:id" element={<ItemDashboard item="products" title="Product" location="/products" />} />
                    <Route path="/products" element={
                      <>
                        <Header title="Products" location="/products" />
                        <PieChart item="products" withCount={true} ignoreNoneOption={'None'} />
                        <DataTable item="products" title="Products" paginate={true} />
                      </>
                    } />
                    <Route path="/teams/:id" element={<ItemDashboard item="teams" title="Team" location="/teams" />} />
                    <Route path="/teams" element={
                      <>
                        <Header title="Teams" location="/teams" />
                        <PieChart item="teams" numSlices="10" withCount={true} />
                        <DataTable item="teams" title="Teams" paginate={true} />
                      </>
                    } />
                    <Route path="/authors/:id" element={<ItemDashboard item="authors" title="Author" location="/authors" />} />
                    <Route path="/authors" element={
                      <>
                        <Header title="Authors" location="/authors" />
                        <PieChart item="authors" withCount={true} />
                        <DataTable item="authors" title="Authors" paginate={true} />
                      </>
                    } />
                    <Route path="/languages/:id" element={<ItemDashboard item="languages" title="Computer Language" location="/languages" />} />
                    <Route path="/languages" element={
                      <>
                        <Header title="Computer Languages" location="/languages" />
                        <PieChart item="languages" numSlices="7" withCount={true} ignoreNoneOption={'None'} />
                        <DataTable item="languages" title="Computer Languages" paginate={true} />
                      </>
                    } />
                    <Route path="/human_languages/:id" element={<ItemDashboard item="human_languages" title="Human Language" location="/human_languages" />} />
                    <Route path="/human_languages" element={
                      <>
                        <Header title="Human Languages" location="/human_languages" />
                        <PieChart item="human_languages" numSlices="3" withCount={true} />
                        <DataTable item="human_languages" title="Human Languages" />
                      </>
                    } />
                    <Route path="/countries/:id" element={<ItemDashboard item="countries" title="Country" location="/countries" countries={user.countries} />} />
                    <Route path="/countries" element={
                      <>
                        <Header title="Countries" location="/countries" />
                        <PieChart item="countries" ignoreNoneOption={'All other countries'} />
                        <DataTable item="countries" title="Countries" />
                      </>
                    } />
                    <Route path="/article_months/:id" element={<ItemDashboard item="article_months" title="Publication Month" location="/article_months" />} />
                    <Route path="/article_months" element={
                      <>
                        <Header title="Publication Month" location="/publication_months" />
                        <PieChart item="article_months" ignoreNoneOption={'Unknown'} />
                        <DataTable item="article_months" title="Publication Month" paginate={true} />
                      </>
                    } />
                    <Route path="/article_quarters/:id" element={<ItemDashboard item="article_quarters" title="Publication Quarter" location="/article_quarters" />} />
                    <Route path="/article_quarters" element={
                      <>
                        <Header title="Publication Quarter" location="/publication_quarters" />
                        <PieChart item="article_quarters" ignoreNoneOption={'Unknown'} />
                        <DataTable item="article_quarters" title="Publication Quarter" paginate={true} />
                      </>
                    } />
                    <Route path="/article_years/:id" element={<ItemDashboard item="article_years" title="Publication Year" location="/article_years" />} />
                    <Route path="/article_years" element={
                      <>
                        <Header title="Publication Year" location="/publication_years" />
                        <PieChart item="article_years" ignoreNoneOption={'Unknown'} />
                        <DataTable item="article_years" title="Publication Year" />
                      </>
                    } />
                    <Route path="/lists/:id/edit" element={<EditList />} />
                    <Route path="/lists/:id" element={<List />} />
                    <Route path="/lists" element={<Lists />} />
                    <Route path="/dashboards/:id" element={<CustomDashboard />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/help" element={<Help />} />
                  </Routes>
                </div>
              </Stack>
            </DataContextProvider>
          </Row>
        </BrowserRouter> 
      }
    </Container>
  );
}
